@let f = form();

<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a
            role="button"
            tabindex="0"
            [attr.aria-label]="'back' | translate"
            (click)="onCancel()"
            (keydown.enter)="onCancel()"
            (keydown.space)="$event.preventDefault(); onCancel()"
        >
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_tab_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form class="form form-horizontal" (submit)="$event.preventDefault()">
        <div class="title">{{ "control_tab_header" | translate }}</div>
        <div class="form-row">
            <div class="form-group mb-10">
                <label class="col-xs-9 control-label">{{ "control_tab_background" | translate }}</label>
                <div class="col-xs-3">
                    <web-color-picker-v2
                        [color]="f.headerBackgroundColor().value()"
                        [ariaLabel]="'control_tab_background' | translate"
                        (colorChangeEvent)="f.setHeaderBackgroundColor($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-9 control-label">{{ "control_tab_active_background" | translate }}</label>
                <div class="col-xs-3">
                    <web-color-picker-v2
                        [color]="f.headerActiveBackgroundColor().value()"
                        [ariaLabel]="'control_tab_active_background' | translate"
                        (colorChangeEvent)="f.setHeaderActiveBackgroundColor($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-12">
                    {{ "control_text" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [min]="FONT_SIZE_MIN"
                        [max]="FONT_SIZE_MAX"
                        [value]="f.headerFontSizeValue().value()"
                        (valueChange)="f.setHeaderFontSize($event)"
                    />
                </div>
                <div class="col-xs-6">
                    <div
                        class="btn-group btn-group-justified"
                        role="group"
                        [attr.aria-label]="'control_text' | translate"
                    >
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey"
                                [class.active]="f.headerTextTransform().value() !== 'initial'"
                                [attr.aria-pressed]="f.headerTextTransform().value() !== 'initial'"
                                [attr.aria-label]="'control_uppercase' | translate"
                                (click)="f.toggleHeaderTextTransform()"
                            >
                                <img src="./assets/img/lpc-icon-uppercase.svg" alt="" />
                            </button>
                        </div>
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey"
                                [class.active]="f.headerFontWeight().value() !== 'initial'"
                                [attr.aria-pressed]="f.headerFontWeight().value() !== 'initial'"
                                [attr.aria-label]="'tui_bold' | translate"
                                (click)="f.toggleHeaderFontWeight()"
                            >
                                <img src="./assets/img/lpc-icon-bold.svg" alt="" />
                            </button>
                        </div>
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey"
                                [class.active]="f.headerFontStyle().value() !== 'initial'"
                                [attr.aria-pressed]="f.headerFontStyle().value() !== 'initial'"
                                [attr.aria-label]="'tui_italic' | translate"
                                (click)="f.toggleHeaderFontStyle()"
                            >
                                <img src="./assets/img/lpc-icon-italic.svg" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker-v2
                        [hideGradient]="true"
                        [color]="f.headerTextColor().value()"
                        [ariaLabel]="'control_text' | translate"
                        (colorChangeEvent)="setHeaderTextColor($event)"
                    />
                    <!--                        (colorChangeEvent)="f.setHeaderTextColor($event)"-->
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-9 control-label">{{ "control_tab_active_text_color" | translate }}</label>
                <div class="col-xs-3">
                    <web-color-picker-v2
                        [color]="f.headerActiveTextColor().value()"
                        [ariaLabel]="'control_tab_active_text_color' | translate"
                        (colorChangeEvent)="f.setHeaderActiveTextColor($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-6 control-label">{{ "control_tab_active_contour" | translate }}</label>
                <div class="col-xs-4">
                    @if (f.placement().value() !== "top") {
                        <div
                            class="btn-group btn-group-justified"
                            role="group"
                            [attr.aria-label]="'control_tab_active_contour' | translate"
                        >
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-grey radio-button"
                                    [class.active]="f.headerActiveContourSide().value() === 'left'"
                                    [attr.aria-pressed]="f.headerActiveContourSide().value() === 'left'"
                                    [attr.aria-label]="'option_animation_position_left' | translate"
                                    (click)="f.toggleHeaderActiveContourSide('left')"
                                >
                                    <img
                                        src="./assets/img/radio-group/lpc-icon-align-top.svg"
                                        style="rotate: -90deg"
                                        alt=""
                                    />
                                </button>
                            </div>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-grey radio-button"
                                    [class.active]="f.headerActiveContourSide().value() === 'right'"
                                    [attr.aria-pressed]="f.headerActiveContourSide().value() === 'right'"
                                    [attr.aria-label]="'option_animation_position_right' | translate"
                                    (click)="f.toggleHeaderActiveContourSide('right')"
                                >
                                    <img
                                        src="./assets/img/radio-group/lpc-icon-align-top.svg"
                                        style="rotate: 90deg"
                                        alt=""
                                    />
                                </button>
                            </div>
                        </div>
                    }
                    @if (f.placement().value() === "top") {
                        <div
                            class="btn-group btn-group-justified"
                            role="group"
                            [attr.aria-label]="'control_tab_active_contour' | translate"
                        >
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-grey radio-button"
                                    [class.active]="f.headerActiveContourSide().value() === 'top'"
                                    [attr.aria-pressed]="f.headerActiveContourSide().value() === 'top'"
                                    [attr.aria-label]="'option_animation_position_top' | translate"
                                    (click)="f.toggleHeaderActiveContourSide('top')"
                                >
                                    <img src="./assets/img/radio-group/lpc-icon-align-top.svg" alt="" />
                                </button>
                            </div>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    class="btn btn-grey radio-button"
                                    [class.active]="f.headerActiveContourSide().value() === 'bottom'"
                                    [attr.aria-pressed]="f.headerActiveContourSide().value() === 'bottom'"
                                    [attr.aria-label]="'option_animation_position_bottom' | translate"
                                    (click)="f.toggleHeaderActiveContourSide('bottom')"
                                >
                                    <img src="./assets/img/radio-group/lpc-icon-align-bottom.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    }
                </div>
                <div class="col-xs-2">
                    <web-color-picker-v2
                        [color]="f.headerActiveContourColor().value()"
                        [ariaLabel]="'control_tab_active_contour' | translate"
                        (colorChangeEvent)="f.setHeaderActiveContourColor($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-6 control-label">
                    {{ "control_padding" | translate }}
                </label>
                <div class="col-xs-6 text-right">
                    <div
                        class="btn-group btn-group-justified"
                        role="group"
                        [attr.aria-label]="'control_padding' | translate"
                    >
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey radio-button"
                                [class.active]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['s'].top"
                                [attr.aria-pressed]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['s'].top"
                                [attr.aria-label]="'control_size_small' | translate"
                                (click)="f.setHeaderPaddingPreset('s')"
                            >
                                <img src="./assets/img/radio-group/lpc-icon-size-small.svg" alt="" />
                            </button>
                        </div>
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey radio-button"
                                [class.active]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['m'].top"
                                [attr.aria-pressed]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['m'].top"
                                [attr.aria-label]="'control_size_medium' | translate"
                                (click)="f.setHeaderPaddingPreset('m')"
                            >
                                <img src="./assets/img/radio-group/lpc-icon-size-medium.svg" alt="" />
                            </button>
                        </div>
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-grey radio-button"
                                [class.active]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['l'].top"
                                [attr.aria-pressed]="f.headerPaddingValue().value().top === f.PADDINGS_MAP['l'].top"
                                [attr.aria-label]="'control_size_large' | translate"
                                (click)="f.setHeaderPaddingPreset('l')"
                            >
                                <img src="./assets/img/radio-group/lpc-icon-size-large.svg" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="form-group"
                [class.mb-10]="useIndividualHeaderRadiusSettings()"
                [class.mb-15]="!useIndividualHeaderRadiusSettings()"
            >
                <label class="col-xs-6 control-label">
                    {{ "control_radius" | translate }}
                </label>
                <div class="col-xs-6 custom-corner-wrapper">
                    <button
                        type="button"
                        [tooltip]="'control_custom_radius_toolip' | translate"
                        placement="top"
                        class="btn btn-action btn-custom-corner"
                        [class.active]="useIndividualHeaderRadiusSettings()"
                        [attr.aria-pressed]="useIndividualHeaderRadiusSettings()"
                        [attr.aria-label]="'control_custom_radius_toolip' | translate"
                        (click)="toggleUseIndividualHeaderRadiusSettings()"
                    >
                        <img src="./assets/img/websites/lpc-corner-icon.svg" alt="" />
                    </button>

                    @if (useIndividualHeaderRadiusSettings()) {
                        <!-- placeholder to mix corners -->
                        <div class="custom-corner-input">
                            <div class="input-group">
                                <input class="form-control" value="Mix" disabled />
                                <div class="input-group-addon">px</div>
                            </div>
                        </div>
                    } @else {
                        <sp-input-num
                            class="custom-corner-input"
                            suffixText="px"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="f.headerBorderRadiusValue().value().topLeft"
                            (valueChange)="f.setAllHeaderBorderRadius($event)"
                        />
                    }
                </div>
            </div>

            @if (useIndividualHeaderRadiusSettings()) {
                <div class="mb-20">
                    <sp-advanced-radius-settings
                        [radiusSettings]="{
                            borderBottomLeftRadius: f.headerBorderRadiusValue().value().bottomLeft,
                            borderBottomRightRadius: f.headerBorderRadiusValue().value().bottomRight,
                            borderTopLeftRadius: f.headerBorderRadiusValue().value().topLeft,
                            borderTopRightRadius: f.headerBorderRadiusValue().value().topRight,
                        }"
                        (valueChangeEvent)="f.setHeaderBorderRadius($event)"
                    />
                </div>
            }

            <div class="form-group row form-horizontal">
                <label class="col-xs-9 control-label">{{ "control_tab_separator" | translate }}</label>

                <div class="col-xs-3 text-right">
                    <sp-switch
                        [active]="f.headerSeparator().value()"
                        [ariaLabel]="'control_tab_separator' | translate"
                        (toggleActiveEvent)="f.setHeaderSeparator($event)"
                    />
                </div>
            </div>

            @if (f.headerSeparator().value()) {
                <div class="form-group">
                    <label class="col-xs-6 control-label">{{ "control_tab_separator_color" | translate }}</label>
                    <div class="col-xs-6">
                        <web-color-picker-v2
                            [color]="f.headerSeparatorColor().value()"
                            [ariaLabel]="'control_tab_separator_color' | translate"
                            (colorChangeEvent)="f.setHeaderSeparatorColor($event)"
                        ></web-color-picker-v2>
                    </div>
                </div>
            }

            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider mb-15" />
                </div>
            </div>
        </div>

        <div class="title">{{ "control_tab_content" | translate }}</div>
        <div class="form-row">
            <div class="form-group mb-15">
                <label class="col-xs-9 control-label">{{ "control_tab_background" | translate }}</label>
                <div class="col-xs-3">
                    <web-color-picker-v2
                        [color]="f.bodyBackgroundColor().value()"
                        [ariaLabel]="'control_tab_background' | translate"
                        (colorChangeEvent)="f.setBodyBackgroundColor($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-6">
                    <label class="control-label">{{ "control_radius" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="f.bodyBorderRadiusValue().value().topLeft"
                        (valueChange)="f.setAllBodyBorderRadius($event)"
                        (blurEvent)="f.setAllBodyBorderRadius($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-15">
                <label class="col-xs-6">
                    {{ "control_padding" | translate }}
                </label>
                <div class="col-xs-6 text-right">
                    <div class="preset-padding-buttons">
                        <button
                            type="button"
                            class="btn btn-default btn-sm btn-inline"
                            (click)="f.setAllBodyPaddings(0)"
                        >
                            0
                        </button>
                        <button
                            type="button"
                            class="btn btn-default btn-sm btn-inline"
                            (click)="f.setAllBodyPaddings(15)"
                        >
                            15
                        </button>
                        <button
                            type="button"
                            class="btn btn-default btn-sm btn-inline"
                            (click)="f.setAllBodyPaddings(30)"
                        >
                            30
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group mb-15">
                <div class="col-xs-12 d-flex">
                    <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="f.bodyPaddingValue().value().left"
                            (valueChange)="f.setBodyPaddingSide('left', $event)"
                        />
                    </div>
                    <div style="flex-grow: 1">
                        <div class="mb-10">
                            <sp-input-num
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="f.bodyPaddingValue().value().top"
                                (valueChange)="f.setBodyPaddingSide('top', $event)"
                            />
                        </div>
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="f.bodyPaddingValue().value().bottom"
                            (valueChange)="f.setBodyPaddingSide('bottom', $event)"
                        />
                    </div>
                    <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="f.bodyPaddingValue().value().right"
                            (valueChange)="f.setBodyPaddingSide('right', $event)"
                        />
                    </div>
                </div>
            </div>

            @if (hasChildrenGridForm()) {
                <div class="form-group">
                    <div class="col-xs-8">
                        <label class="control-label">{{ "control_tab_widget_spacing" | translate }}</label>
                    </div>
                    <div class="col-xs-4">
                        <sp-input-num
                            suffixText="px"
                            [min]="0"
                            [max]="100"
                            [value]="childrenGridForm.gapXValue().value()"
                            (valueChange)="setStructureGap($event)"
                        />
                    </div>
                </div>
            }
        </div>
    </form>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
